document.addEventListener('click', function (e) {
  const wrap = e.target.closest('.ask-ai');
  if (!wrap) return;

  const title = wrap.dataset.aiTitle;
  const price = wrap.dataset.aiPrice;
  const desc = wrap.dataset.aiDesc;
  const url = wrap.dataset.aiUrl;

  const prompt =
    `Tengo dudas sobre este producto de Edifica Hogar (Uruguay): "${title}", precio ${price}. ` +
    `Descripción: ${desc}. Más info acá: ${url}. Ayudame a decidir si me sirve y respondé mis preguntas sobre él.`;

  const chatgptBtn = e.target.closest('[data-action="ask-chatgpt"]');
  if (chatgptBtn) {
    const gptUrl = 'https://chatgpt.com/?q=' + encodeURIComponent(prompt);
    window.open(gptUrl, '_blank', 'noopener');
    return;
  }

  const copyBtn = e.target.closest('[data-action="copy-ai"]');
  if (copyBtn) {
    navigator.clipboard.writeText(prompt).then(function () {
      copyBtn.classList.add('is-copied');
      setTimeout(function () {
        copyBtn.classList.remove('is-copied');
      }, 1800);
    });
  }
});